export enum SpokenLanguageType {
    NoRequirements = 0,
    Other = 1,
    Braille = 2,
}
